import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { useHistory } from "react-router-dom";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import usePerformanceAnalyticsHistoric from "./usePerformanceAnalyticsHistoric";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import AverageGraphic from "./averageGraphic";
import DetailGrid from "./detailGrid";

const YEARS_ARRAY = [
  { value: "allHistorical", key: "" },
  { value: "last3Years", key: "3" },
  { value: "last5Years", key: "5" },
  { value: "last10Years", key: "10" },
];

const PerformanceAnalyticsHistoric = () => {

  const {
    isLoading,
    averagePerformanceData,
    averagePotentialData,
    detailData,
    state,
    handlers,
  } = usePerformanceAnalyticsHistoric();

  const history = useHistory();

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString('goBack')}
      onClick={() => history.push(paths.performanceAnalytics)}
      type={'goBack'}
    />
  )

  const customHeader = () =>
    <div style={{ width: 300, marginLeft: 10, marginRight: 10 }}>
      <FormControl style={{ width: "100%" }}>
        <InputLabel shrink id={`label-years`}>{getLocalizedString("yearsToCheck")}</InputLabel>
        <Select
          value={state.years}
          labelId={`label-years`}
          id={`select-years`}
          onChange={(e) => handlers.handleChangeYears(e.target.value)}
          margin={"none"}
          displayEmpty
        >
          {
            YEARS_ARRAY.map(item => (
              <MenuItem
                className={"whiteText"}
                key={item.key}
                value={item.key}
              >
                {getLocalizedString(item.value)}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>
    </div>

  return (
    <CommonPage
      isLoading={isLoading}
      title={getLocalizedString("performanceAnalyticsHistoric")}
      customHeader={customHeader}
      menuItems={[goBackButton]}
      isNotGridPage
      hasSwitch
      handleSwitchClick={handlers.handleChangeIncludeCurrentYearProcesses}
      switchValue={state.includeCurrentYearProcesses}
      switchLabelOn={getLocalizedString("includeCurrentYearProcesses")}
      switchLabelOff={getLocalizedString("includeCurrentYearProcesses")}
    >
      <div style={{ margin: "0px 24px" }}>
        {
          Boolean(averagePerformanceData.length) &&
          <AverageGraphic
            title={getLocalizedString("overallPerformanceAverageByEvaluation")}
            data={averagePerformanceData}
          />
        }
        {
          Boolean(averagePotentialData.length) &&
          <AverageGraphic
            title={getLocalizedString("globalPotentialAverageByEvaluation")}
            data={averagePotentialData}
          />
        }
        <DetailGrid
          title={getLocalizedString("performanceEvaluationsDetailsForHistoricalAnalysis")}
          data={detailData}
        />
      </div>
    </CommonPage>
  );
}

export default PerformanceAnalyticsHistoric;
